"use client";

import useTimeLeft from "@/app/hooks/useTimeLeft";
import styles from "./styles.module.css";

export default function TimeRemaining({ end }: { end: number }) {
  const timeLeft = useTimeLeft(end);
  return <div className={styles.timeRemaining}>{timeLeft}</div>;
}
